import { EventEmitter } from 'events'

export default class Jump extends EventEmitter {
	_activityTimer
	_createActivityTimer

	onActivityReportInterval = () => this.reportActivity()

	onBeforeUnload = () => this.reportActivity()

	onMessage = e => {
		if (typeof document === 'undefined' || !document.referrer.startsWith(e.origin)) return
		const { type, payload } = e.data
		switch (type) {
			case 'init':
				const { activityReportMs, activityIdleCheckMs } = payload
				this._activityTimer = this._createActivityTimer(activityIdleCheckMs)
				this._activityTimer.start()
				this._activityReportInterval = setInterval(this.onActivityReportInterval, activityReportMs)
				window.addEventListener('onbeforeunload', this.onBeforeUnload)
				this.emit('init', payload)
				break
			case 'fullscreen':
				this.emit('fullscreen', payload)
				break
		}
	}

	constructor({ createActivityTimer }) {
		super()
		this._createActivityTimer = createActivityTimer
	}

	sendMessage(type, payload) {
		window.parent.postMessage({ type, payload }, '*')
	}

	reportActivity() {
		const times = this._activityTimer.getTimes()
		if (times) this.sendMessage('activity', times)
	}

	progress(amount) {
		this.sendMessage('progress', amount)
	}

	start(payload) {
		window.addEventListener('message', this.onMessage)
		this.sendMessage('start', { ...payload, willReportActivity: true })
	}

	exit() {
		if (this._activityTimer) {
			clearInterval(this._activityReportInterval)
			this._activityTimer.stop()
			this.reportActivity()
			window.removeEventListener('onbeforeunload', this.onBeforeUnload)
		}
		window.removeEventListener('message', this.onMessage)
		this.sendMessage('exit')
	}
}



// WEBPACK FOOTER //
// ./src/Jump.js